export enum MeasuredRefEnum {
    START = 'START',
    END= 'END', 
    MID = 'MID',
    // CUSTOM = 'CUSTOM'
}